module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Anchor-left-6dd28438a6b390aba90749b25ad23e6c.svg";